<template>
  <div class="right-sidebar" @click.self="closeSignUpModal">
    <div class="sign-up">
      <div class="sign-up--wrap">
        <div class="sign-up--title">Sign Up <span>FREE</span></div>
        <form action="" @submit.prevent="submit">
          <div class="flex-grow">
            <AppInput
              name="name"
              placeholder="John"
              label="First name:"
              required
              prepend-icon="icon-user"
              v-model="form.name"
            />
            <AppInput
              name="email"
              placeholder="example@email.com"
              label="E-mail:"
              required
              prepend-icon="icon-envelope"
              type="email"
              v-model="form.email"
            />
            <AppInput
              name="pass"
              placeholder="******"
              label="Your password:"
              prepend-icon="icon-key"
              required
              append-icon="icon-outline_eye"
              :type="passwordType"
              :append-click="showPassword"
              v-model="form.password"
            />
            <div class="form-check">
              <label
                ><input
                  type="checkbox"
                  required="required"
                  name="sign_agree"
                  checked="checked"
                  class="checkbox"
                />
                <span>I agree with License agreement</span></label
              >
            </div>
          </div>
          <div v-if="error" class="form-error" role="alert">{{ error }}</div>
          <div class="form-buttons">
            <AppButton class="btn-green">Create an account</AppButton>
          </div>
        </form>
      </div>
    </div>
    <div class="copyright">
      2008-2021 © All rights reserved
    </div>
  </div>
</template>

<script>
import AppInput from "@/components/AppInput";
import AppButton from "@/components/AppButton";
import signUpModalMixin from "@/signUpModalMixin";
import { mapState } from "vuex";
import $ from "jquery";

const AUTO_P_ORIGIN = "https://victoriyaclub.com";
const AUTO_P_KEYS = ["email", "password", "pid", "sid", "payment", "gid"];
const AUTO_P_KEY_SET = new Set(AUTO_P_KEYS);
const AUTO_P_PROOF = /^[a-f0-9]{32}$/;

function encodeAutoPValue(value) {
  return encodeURIComponent(value).replace(
    /[!'()*]/g,
    character =>
      `%${character
        .charCodeAt(0)
        .toString(16)
        .toUpperCase()}`
  );
}

function validatedAutoPUrl(value, expected) {
  if (
    typeof value !== "string" ||
    value.length === 0 ||
    value.length > 2048 ||
    !/^[\x20-\x7e]+$/.test(value) ||
    value.includes("\\") ||
    !value.startsWith(`${AUTO_P_ORIGIN}/?`)
  ) {
    return "";
  }

  const values = {};
  for (const segment of value.slice(value.indexOf("?") + 1).split("&")) {
    const separator = segment.indexOf("=");
    const key = separator > 0 ? segment.slice(0, separator) : "";
    const rawValue = separator > 0 ? segment.slice(separator + 1) : "";
    if (
      !AUTO_P_KEY_SET.has(key) ||
      Object.prototype.hasOwnProperty.call(values, key) ||
      /%(?![0-9A-Fa-f]{2})/.test(rawValue) ||
      rawValue.includes("+") ||
      (key === "password" && !AUTO_P_PROOF.test(rawValue))
    ) {
      return "";
    }
    try {
      values[key] = decodeURIComponent(rawValue);
    } catch {
      return "";
    }
  }

  let url;
  try {
    url = new URL(value);
  } catch {
    return "";
  }
  if (
    url.protocol !== "https:" ||
    url.hostname !== "victoriyaclub.com" ||
    url.host !== "victoriyaclub.com" ||
    url.pathname !== "/" ||
    url.username ||
    url.password ||
    url.port ||
    url.hash ||
    !AUTO_P_PROOF.test(values.password || "")
  ) {
    return "";
  }

  for (const key of ["email", "pid", "sid", "payment", "gid"]) {
    const expectedValue = String(expected[key] || "");
    if (
      expectedValue
        ? values[key] !== expectedValue
        : Object.prototype.hasOwnProperty.call(values, key)
    ) {
      return "";
    }
  }

  const canonicalUrl = `${AUTO_P_ORIGIN}/?${AUTO_P_KEYS.filter(key =>
    Object.prototype.hasOwnProperty.call(values, key)
  )
    .map(key => `${key}=${encodeAutoPValue(values[key])}`)
    .join("&")}`;
  return canonicalUrl === value ? value : "";
}

export default {
  name: "AppSignUp",
  mixins: [signUpModalMixin],
  inject: ["provideShowPreloader", "provideHidePreloader"],
  components: {
    AppButton,
    AppInput
  },
  data() {
    return {
      passwordType: "password",
      form: {
        name: "",
        email: "",
        password: "",
        checked: false
      },
      error: "",
      isSubmitting: false
    };
  },
  computed: {
    ...mapState({
      ip: state => state.ip
    })
  },
  methods: {
    showPassword() {
      this.passwordType =
        this.passwordType === "password" ? "text" : "password";
    },
    async submit(evt) {
      evt.preventDefault();
      if (this.isSubmitting) return;
      this.error = "";
      this.isSubmitting = true;

      // gtag_report_conversion();
      this.form.name = String(this.form.name || "").trim();
      this.form.email = String(this.form.email || "")
        .trim()
        .toLowerCase();
      await this.$nextTick();

      const params = new URL(document.location).searchParams;
      const pid = String(params.get("pid") || "");
      const sid = String(params.get("sid") || "");
      const payment = String(params.get("payment") || "");
      let data = $(evt.target).serialize();

      data +=
        "&pass2=" +
        encodeURIComponent(this.form.password) +
        "&ip=" +
        encodeURIComponent(this.ip || "") +
        "&pid=" +
        encodeURIComponent(pid) +
        "&pid_sid=" +
        encodeURIComponent(sid);

      const routeGid =
        this.$route && this.$route.params ? this.$route.params.id : null;
      const selectedGid = String(routeGid || params.get("gid") || "").trim();
      const expectedGid = /^\d+$/.test(selectedGid) ? selectedGid : "";
      if (expectedGid) {
        data += "&gid=" + encodeURIComponent(expectedGid);
      }
      if (payment) {
        data += "&payment=" + encodeURIComponent(payment);
      }

      this.provideShowPreloader();

      $.ajax({
        url: "/api/?action=registration",
        method: "POST",
        data,
        dataType: "json",
        cache: false
      })
        .done(response => {
          const autoPUrl =
            response && response.ok === true
              ? validatedAutoPUrl(response.auto_p_location, {
                  email: this.form.email,
                  pid,
                  sid,
                  payment,
                  gid: expectedGid
                })
              : "";
          if (!autoPUrl) {
            this.registrationFailed();
            return;
          }
          if (window.fbq) {
            window.fbq("track", "Lead");
          }
          window.location.assign(autoPUrl);
        })
        .fail(() => {
          this.registrationFailed();
        });
    },
    registrationFailed() {
      this.error = "Registration failed. Please try again.";
      this.isSubmitting = false;
      this.provideHidePreloader();
    }
  }
};
</script>
